// Third Party Imports
import React from 'react';
import {ButtonLink} from '@homeaway/react-buttons';

// Relative Imports
import './Header.less';
import Help from '../Help/HelpContainer';
import logoMapper from '../../utils/logoMapper';
import {localizeUrl} from '@homeaway/localization-utils';
import {Dropdown} from '@homeaway/react-dropdown';
import { isUsSite } from '../../../../build/universal/utils/validate';
import {redirectToQCWebform, unSupportedWebformSites, redirectToVrboLandingPage} from '../utils/webFormUtil';
import {WEBFORM} from '../../utils/constants'

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.onSignInClick = this.onSignInClick.bind(this);
        this.onHelpClick = this.onHelpClick.bind(this);
        this.onCollapseClick = this.onCollapseClick.bind(this);
    }

    triggerEdapEventOnHelpClick() {
        this.props.triggerEdapEvent('generic.click', {
            eventcategory: 'Help'
        }, {});
    }

    triggerEdapEventOnClick(eventCategory) {
        this.props.triggerEdapEvent('generic.click', {
            eventcategory: eventCategory
        }, {});
    }

    onSignInClick() {
        const {preferredLocale, environment, nodeEnvironment, siteName} = this.props;

        if (preferredLocale === 'ja_JP' || siteName === 'homeaway_jp') {
            redirectToQCWebform('', preferredLocale, environment, nodeEnvironment);
        } else {
            this.props.changeAppState('BRAND_DETERMINATION');
        }
        document.getElementById('navbar-overlay').classList.toggle('overlay-visibility');
        document.getElementById('header-navbar-collapse').classList.toggle('collapse');
        this.triggerEdapEventOnClick('Sign up');
    }

    onHelpClick() {
        this.props.toggleHelpModal(true, 'helpModal');
        this.triggerEdapEventOnHelpClick();
    }

    onCollapseClick() {
        document.getElementById('navbar-overlay').classList.toggle('overlay-visibility');
        document.getElementById('header-navbar-collapse').classList.toggle('collapse');
    }

    handleLanguageSelection = (event) => {
        const {authState, publicUuid} = this.props;

        const {target} = event;
        const href = target ? target.getAttribute('href') : '';
        const preferredLocale = href.split('=')[1];

        if (authState) {
            this.props.savePreferredLocale(publicUuid, preferredLocale);
        }
    }

    getHeaderStyle() {
        let {authState, isWebFormPage, skipComponent, preferredLocale, siteName, environment, nodeEnvironment} = this.props;
        const loginUrl = (isWebFormPage || preferredLocale === 'ja_JP' || siteName === 'homeaway_br' || siteName === 'homeaway_jp') ? `${WEBFORM.prefix}/login` : '/p/onboard/login';
        let logoutUrl;

        if (unSupportedWebformSites(siteName)) {
            logoutUrl = redirectToVrboLandingPage(environment, nodeEnvironment);
        } else {
            const logoutHref = (isWebFormPage || preferredLocale === 'ja_JP') ? `${WEBFORM.prefix}/logout` : '/p/onboard/logout';
            logoutUrl = (typeof window !== 'undefined') ? localizeUrl(logoutHref, window.__SITE_CONTEXT__) : null;
        }

        const headerStyle = {};
        if (authState) {
            headerStyle.authHref = logoutUrl;
            headerStyle.authText = this.props.translations['ipmob.header.logout'];
            headerStyle.siteHeaderStyle = 'site-header';
            headerStyle.buttonId = 'logout';
        } else {
            headerStyle.authHref = (typeof window !== 'undefined') ? localizeUrl(loginUrl, window.__SITE_CONTEXT__) : null;
            headerStyle.authText = this.props.translations['ipmob.header.login'];
            headerStyle.siteHeaderStyle = (skipComponent) ? 'site-header' : 'site-header header-bg-white';
            headerStyle.buttonId = 'login';
        }

        return headerStyle;
    }

    getDefaultLogo(logoDetails) {
        const {isLandingPage} = this.props;
        let logoClassName;

        if (logoDetails.isDefaultLogo) {
            logoClassName = 'header-panel';
        } else if (isLandingPage) {
            logoClassName = 'header-panel landing-page-logo';
        } else {
            logoClassName = 'header-panel other-brand-logo';
        }

        return logoClassName;
    }

    getSelectedLocale = () => {
        const {supportedLocales, preferredLocale} = this.props;
        const selectedLocale = supportedLocales.filter((supportedLocale) => {
            return supportedLocale.locale === preferredLocale;
        })[0];

        return selectedLocale;
    }

    render() {
        const {
            translations,
            skipComponent,
            logoBrandName,
            siteName,
            supportedLocales,
            isLandingPage,
            authState,
            isWebFormPage,
            helpLinkTexts
        } = this.props;

        const headerStyle = this.getHeaderStyle();
        const logoDetails = logoMapper(`${siteName}`, `${logoBrandName}`);
        const selectedLocale = this.getSelectedLocale();

        return (
            <div id="header" className="header">
                <Help/>
                <div className= {(skipComponent) ? 'landing-page-header' : headerStyle.siteHeaderStyle}>
                    <div className={this.getDefaultLogo(logoDetails)}>
                        <div className="logo-holder">
                            <img alt="Vrbo logo" className={'logo'} src={logoDetails.logo}/>
                        </div>
                        <div className="header-btn-holder">
                            <div id="navbar-overlay" className="overlay"/>
                            <nav className="navbar navbar-inverse navbar-static-top" role="navigation">
                                <div className="container">
                                    <div className="navbar-header">
                                        <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#header-navbar-collapse" onClick={this.onCollapseClick} href="#">
                                            <span className="sr-only">{'Toggle navigation'}</span>
                                            <span className="icon-bar" />
                                            <span className="icon-bar" />
                                            <span className="icon-bar" />
                                        </button>
                                    </div>
                                    <div className="collapse navbar-collapse" id="header-navbar-collapse">
                                        <ul className="nav navbar-nav">
                                            <li>
                                                {
                                                    ((isLandingPage || authState) && (!isWebFormPage && isUsSite(siteName)))
                                                        ? (
                                                            <Dropdown
                                                                label={`${selectedLocale.languageName}`}
                                                                id="supportedLocale"
                                                                className="supported-locale"
                                                            >
                                                                {
                                                                    supportedLocales.map((locales, index) => <li key={`${index}`}><a href={`${locales.link}`} onClick={this.handleLanguageSelection}>{locales.languageName}</a></li>)
                                                                }
                                                            </Dropdown>)
                                                        : null
                                                }
                                            </li>
                                            <li>
                                                {
                                                    (skipComponent)
                                                        ? (
                                                            <ButtonLink
                                                                type="button"
                                                                id={'signUp'}
                                                                className={'button-white'}
                                                                size="sm"
                                                                label={translations['ipmob.header.signup']}
                                                                onClick={this.onSignInClick}
                                                                href="#"
                                                            >
                                                                <span className="caret" />
                                                            </ButtonLink>)
                                                        : null
                                                }
                                            </li>
                                            <li>
                                                <ButtonLink
                                                    type="button"
                                                    id={headerStyle.buttonId}
                                                    size="sm"
                                                    label={headerStyle.authText}
                                                    href={headerStyle.authHref}
                                                >
                                                    <span className="caret" />
                                                </ButtonLink>
                                            </li>
                                            <li>
                                                {
                                                    (isWebFormPage)
                                                        ? (
                                                            <Dropdown
                                                                label={translations['ipmob.header.help']}
                                                                id="helpLinkTexts"
                                                                className="help-link-text"
                                                            >
                                                                {
                                                                    helpLinkTexts.map((helpLinkText, index) => (
                                                                        <li
                                                                            key={`${index}`}
                                                                        >
                                                                            <a href={`${helpLinkText.link}`}>{`${helpLinkText.text}`}</a>
                                                                        </li>))
                                                                }
                                                            </Dropdown>)
                                                        : null
                                                }
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
